import { useEffect, useState } from 'react';

// Chrome and Edge (Android, desktop) fire beforeinstallprompt when the site can be installed; keep
// the event so Settings can offer a real "install" button. Registered at load, before it fires.
let installEvent = null;
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installEvent = event;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    installEvent = null;
    notify();
  });
}

export const useInstallPrompt = () => {
  const [available, setAvailable] = useState(!!installEvent);
  useEffect(() => {
    const listener = () => setAvailable(!!installEvent);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);

  const install = async () => {
    if (!installEvent) return false;
    installEvent.prompt();
    const { outcome } = await installEvent.userChoice;
    installEvent = null;
    notify();
    return outcome === 'accepted';
  };
  return { available, install };
};

const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;

// iPadOS reports itself as a Mac, so also check for touch.
export const isIOS = /iPhone|iPad|iPod/.test(ua)
  || (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

// Safari on iOS has "Add to Home Screen"; other iOS browsers (Chrome, Edge, Firefox) have it in their own share menu.
export const iosBrowser = /CriOS/.test(ua) ? 'Chrome' : /EdgiOS/.test(ua) ? 'Edge' : /FxiOS/.test(ua) ? 'Firefox' : 'Safari';

// True when the site was opened from its home-screen icon.
export const isStandalone = () => typeof window !== 'undefined'
  && (window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches);
